// extracted by mini-css-extract-plugin
export default {"providersBanner":"providers-banner-module--providersBanner--BI9HB"};